import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "COURSE",
    applicationRights: Rights,
    title: 'Kurs',
    text: 'Kurs',
    icon: 'graduation-cap',
    url: "/course",
    mobileThreshold: 1024,
    sequenceNo: 15000,
    routes: Routes
})
